import React, { useState, useEffect } from "react";
import moment from "moment";
import momentTz from "moment-timezone";
// import "moment/locale/da";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { textTranslate } from "../../utils/i18n";

// Add export module to highChart
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);

const SchedulingChartComp = (props) => {
  const { seriesData, chartResize } = props;
  const [chartConfig, setChartConfig] = useState({
    chart: {
      type: "area",
      zoomType: "x",
      panning: true,
      panKey: "shift",
      reflow: true,
      spacingTop: 30,
      height: props.height ? props.height : 150,
      scrollablePlotArea: {
        // minWidth: 600
      },
    },

    title: {
      text: " ",
    },
    subtitle: {
      text: " ",
    },

    yAxis: {
      title: {
        text: " ",
      },
    },

    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
    },
    xAxis: {
      type: "datetime",
      tickPixelInterval: 50,

      dateTimeLabelFormats: {
        millisecond: "%H:%M:%S.%L",
        second: "%H:%M:%S",
        minute: "%H:%M",
        hour: "%H:%M",
        day: "%e. %b",
        week: "%e. %b",
        month: "%b '%y",
        year: "%Y",
      },
    },
    series: [
      {
        dataGrouping: {
          enabled: false,
        },
      },
    ],
    time: {
      time: "",
      getTimezoneOffset: function (timestamp) {
        var zone = momentTz.tz.guess(),
          timezoneOffset = -moment.tz(timestamp, zone).utcOffset();

        return timezoneOffset;
      },
    },
    colors: ["#6CF", "#39F", "#06C", "#036", "#000"],

    lang: {
      loading: "Aguarde...",
      months: moment.months(),
      weekdays: moment.weekdays(),
      shortMonths: moment.monthsShort(),
    },
  });
  let yAxiSoftMax = 0;

  useEffect(() => {
    let _newSerises = [];
    let plotBands = [];
    for (let deviceIndex = 0; deviceIndex < props.DevicesData.length; deviceIndex++) {
      // eslint-disable-next-line
      const deviceData = props.DevicesData[deviceIndex];
      const seriesData = props.seriesesData[deviceIndex];
      if (
        deviceData.serviceSchedule !== null &&
        deviceData.serviceSchedule !== undefined &&
        deviceData.serviceSchedule.hasOwnProperty("serviceTargetCount")
      )
        plotBands.push({
          dashStyle: "solid", // Style of the plot line. Default to solid
          width: 2, // Width of the line
          value: deviceData.serviceSchedule.serviceTargetCount,
          color: "red",
          zIndex: 200,
          // label: {
          //   text: 'service Target', // Content of the label.
          //   align: 'left', // Positioning of the label.

          // }
        });
      let _data_arr = [];
      let _ref_arr = [];
      seriesData[0].forEach((dataReading) => {
        _data_arr.push([Date.parse(dataReading.ts), dataReading.v]);
      });
      _newSerises.push({
        name: textTranslate("schedulingChartData"),
        type: "column",
        data: _data_arr,
        pointWidth: 20,
        color: "#20a8d8",
      });
      if (seriesData[1].length) {
        seriesData[1].forEach((dataReading) => {
          _ref_arr.push([Date.parse(dataReading.ts), dataReading.v]);
        });
        _newSerises.push({
          name: textTranslate("resets"),
          // type: "scatter",
          type: "spline",
          data: _ref_arr,
          color: "#555",
          lineWidth: 0,
          radius: 4,
          marker: {
            enabled: true,
            radius: 4,
            symbol: "circle",
          },
          tooltip: {
            valueDecimals: 2,
          },
          states: {
            hover: {
              lineWidthPlus: 0,
            },
          },
        });
      }
      if (
        deviceData.hasOwnProperty("serviceSchedule") &&
        deviceData.serviceSchedule !== null &&
        deviceData.serviceSchedule.hasOwnProperty("serviceTargetCount")
      ) {
        yAxiSoftMax =
          yAxiSoftMax < deviceData.serviceSchedule.serviceTargetCount
            ? deviceData.serviceSchedule.serviceTargetCount
            : yAxiSoftMax;
        // _newSerises.push({
        //   name: textTranslate("chartServiceTargetCount"),
        //   // name: "serviceTargetCount",
        //   type: "spline",
        //   data: [[Date.parse(seriesData[0][0].ts), deviceData.serviceSchedule.serviceTargetCount]],
        //   value: deviceData.serviceSchedule.serviceTargetCount,
        //   color: "red"
        // });
      }
    }
    setChartConfig({
      ...chartConfig,
      series: [..._newSerises],
      xAxis: {
        type: "datetime",
        dateTimeLabelFormats: getDateFormat(),
      },
      yAxis: {
        plotBands: plotBands,
        softMax: yAxiSoftMax,
      },
    });

    return () => {};
  }, [seriesData]);

  function getDateFormat() {
    switch (props.period.value) {
      case "day":
        return {
          hour: "%H:%M",
        };
      case "week":
        return {
          day: "%e. %b",
        };
      case "month":
        return {
          day: "%e. %b",
        };
      default:
        break;
    }
  }

  useEffect(() => {
    Highcharts.charts.forEach((chart) => chart !== undefined && chart.reflow());
  }, [[], chartResize]);

  return (
    <React.Fragment>
      {!!chartConfig && (
        <React.Fragment>
          <HighchartsReact highcharts={Highcharts} options={chartConfig} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default SchedulingChartComp;
